<template lang="html">
  <v-text-field
    class="password-filed"
    v-model="internalValue"
    :label="label"
    :rules="rules || []"
    :placeholder="placeholder || ' '"
    outlined
    dense
    :type="showPassword ? 'text' : 'password'"
    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
    @click:append="showPassword = !showPassword"/>
</template>

<script>
export default {
  name: 'PasswordField',
  props: {
    value: String,
    label: String,
    rules: Array,
    placeholder: String,
  },
  data() {
    return {
      showPassword: false,
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
